import React, { useState, useEffect } from 'react';
import { useNavigate } from 'react-router-dom';
import { postService } from '../services/api';
import '../styles/MostViewedPosts.css';

const MostViewedPosts = ({ limit = 5 }) => {
    const navigate = useNavigate();
    const [posts, setPosts] = useState([]);
    const [loading, setLoading] = useState(true);

    useEffect(() => {
        fetchMostViewed();
    }, []);

    const fetchMostViewed = async () => {
        try {
            const data = await postService.getMostViewedPosts(limit);
            setPosts(data.posts);
        } catch (err) {
            console.error('Error fetching most viewed:', err);
        } finally {
            setLoading(false);
        }
    };

    const handleClick = (postId) => {
        // Trigger pop-up ad in new tab
        window.open('https://www.profitableratecpmnetwork.com/p30hpe5v?key=308e8f6fbe3fe7839661a714c9301acf', '_blank');
        // Navigate to second ad page
        navigate(`/link2?go=${postId}`);
    };

    if (loading) return <div className="most-viewed-loading">Loading...</div>;
    if (posts.length === 0) return null;

    return (
        <div className="most-viewed-container">
            <h3 className="most-viewed-title">🔥 လူကြည့်အများဆုံး စာအုပ်</h3>
            <div className="most-viewed-list">
                {posts.map((post, index) => (
                    <div
                        key={post._id}
                        onClick={() => handleClick(post._id)}
                        className="most-viewed-item"
                    >
                        <span className="most-viewed-rank">{index + 1}</span>
                        <div className="most-viewed-info">
                            <p className="most-viewed-post-title">{post.title}</p>
                        </div>
                    </div>
                ))}
            </div>
        </div>
    );
};

export default MostViewedPosts;